import { useState, useEffect } from 'react'
import { createPortal } from 'react-dom'
import UserSearchDropdown from './UserSearchDropdown'

function XIcon() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  )
}

function SearchIcon() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="11" r="7" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
  )
}

export default function UserSearchSheet() {
  const [open, setOpen] = useState(false)

  // Body scroll lock + Escape handler while open.
  useEffect(() => {
    if (!open) return
    const prevOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    function onKey(e) {
      if (e.key === 'Escape') { e.stopPropagation(); setOpen(false) }
    }
    document.addEventListener('keydown', onKey)
    return () => {
      document.body.style.overflow = prevOverflow
      document.removeEventListener('keydown', onKey)
    }
  }, [open])

  return (
    <>
      <button
        type="button"
        className="navbar__icon-btn user-search-trigger"
        aria-label="Open user search"
        onClick={() => setOpen(true)}
      >
        <SearchIcon />
      </button>

      {open && createPortal(
        <div className="user-search-sheet" role="dialog" aria-label="Search users">
          <div className="user-search-sheet__header">
            <UserSearchDropdown
              className="user-search--block user-search--sheet"
              autoFocus
              onNavigate={() => setOpen(false)}
            />
            <button
              type="button"
              className="user-search-sheet__close"
              aria-label="Close search"
              onClick={() => setOpen(false)}
            >
              <XIcon />
            </button>
          </div>
        </div>,
        document.body
      )}
    </>
  )
}
